export default {"src":"/_next/static/media/google-maps-icon.da133706.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};